






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InputTextArea extends Vue {
  @Prop() value: string;
  @Prop() label: string;
  @Prop() placeholder?: string;
  @Prop({ default: 6 }) rows?: number;
  @Prop() disabled?: boolean;
  @Prop({ default: true }) translate?: boolean;
  @Prop() completed?: boolean;
  @Prop({ default: false }) doFocus?: boolean;
  @Prop() maxLength: number;

  computedValue: string = '';
  characterLimit: number = 0;

  mounted() {
    this.computedValue = this.value;
    this.characterLimit = this.maxLength - 1;
  }

  @Watch('value')
  @Watch('computedValue')
  update() {
    this.computedValue =
      this.maxLength && this.computedValue
        ? this.computedValue.substring(0, this.characterLimit)
        : this.computedValue;
  }

  handleInput(event: Event): void {
    this.$emit('input', (event.target as HTMLTextAreaElement).value);
  }

  handleChange(event: Event): void {
    this.$emit('change', (event.target as HTMLTextAreaElement).value);
  }

  handleBlur(event: Event): void {
    this.$emit('blur', (event.target as HTMLTextAreaElement).value);
  }
}
